import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import { setActiveModule } from "../../../actions/sideBarActions";
import Loader from "../../Loader/Loader";
import NotAnAdmin from "../../SettingsContainer/NotAnAdmin";
import { publishRolesRequired } from "../../Sidebar/Menu/Menu";

const LoadableSMP = lazy(() => import("./SMP"));
const LoadableSMPAssets = lazy(() => import("./AssetsPage/AssetsPage"));
const LoadableSettings = lazy(() => import("./Settings/Settings"));
const LoadableSMPAnalytics = lazy(() => import("./SMPAnalytics/SMPAnalytics"));

const SMPRoutes = (props) => {
    const dispatch = useDispatch();

    const activeModule = useSelector((state) => state.sidebarReducer.activeModule);

    const user = useSelector((state) => state.globalReducer.user);
    const packageObj = useSelector((state) => state.globalReducer.packageObj);

    useEffect(() => {
        if (activeModule !== "Publishing" && publishRolesRequired.some((role) => user?.roles.includes(role))) {
            localStorage.setItem("activeModule", "Publishing");
            dispatch(setActiveModule("Publishing"));
        }
    }, []);

    return (
        <>
            {packageObj?.features?.smp_module_access?.quota === 1 || packageObj.package_code === "free" ? (
                <Suspense fallback={<Loader />}>
                    <Switch>
                        {<Route path="/social-media-publishing/settings" render={(props) => <LoadableSettings {...props} />} />}
                        <Route path="/social-media-publishing/assets" render={(props) => <LoadableSMPAssets {...props} />} />
                        <Route path="/social-media-publishing/analytics" render={(props) => <LoadableSMPAnalytics {...props} />} />
                        <Route path="/social-media-publishing" render={(props) => <LoadableSMP {...props} />} />
                    </Switch>
                </Suspense>
            ) : (
                <NotAnAdmin {...props} companyLevelAccessDenied />
            )}
        </>
    );
};

export default SMPRoutes;
